<template>
  <div class=" ">
    <slot />
    <div class="flex justify-center space-x-2 -mt-1" v-if="isActive">
      <button
        @click="$router.push('/confirm/unsubscribe')"
        class="sub-btn-bg text-white text-center rounded-md md:py-1 md:px-8 px-4 py-2 md:text-[1.2vw] text-[12px] truncate"
      >
        إلفاء الإشتراك
      </button>

      <button
        @click="logout"
        class="border border-color text-white text-center rounded-md md:py-1 md:px-8 px-4 py-2 md:text-[1.2vw] text-[12px] truncate"
      >
        تسجيل خروج
      </button>
    </div>
    <div class="flex justify-center space-x-2 -mt-1" v-else>
      <router-link to="/auth/subscribe">
        <button
          class="sub-btn-bg text-white text-center rounded-md md:py-1 md:px-8 px-4 py-2 md:text-[1.2vw] text-[12px] truncate"
        >
          اشترك الان
        </button>
      </router-link>
      <router-link to="/login">
        <button
          class="border border-color text-white text-center rounded-md md:py-1 md:px-8 px-4 py-2 md:text-[1.2vw] text-[12px] truncate"
        >
          تسجيل دخول
        </button>
      </router-link>
    </div>
  </div>
</template>

<script>
import { ISACTIVE } from "@/constants";
import { useAuthStore } from "@/stores/auth";
import { mapActions } from "pinia";
import { useToast } from "vue-toastification";

export default {
  components: {
    // SpinnerView,
  },
  data() {
    return {
      user: false,
      isActive: false,
      isDone: false,
      toast: useToast(),
    };
  },
  async mounted() {
    await this.checkIsActiveAction();

    // Set up watcher for store state changes
    this.setupStoreWatcher();
  },
  watch: {
    // Watch local isActive changes
    isActive(newValue, oldValue) {
      console.log("Local isActive changed:", { newValue, oldValue });
    },
  },
  methods: {
    ...mapActions(useAuthStore, ["wipeUserData"]),

    setupStoreWatcher() {
      const authStore = useAuthStore();

      // Watch the store's isActive state
      this.$watch(
        () => authStore.isActive,
        (newValue) => {
          this.isActive = newValue;
        },
        { immediate: true }
      );
    },

    async checkIsActiveAction() {
      // Update both store and local state from localStorage
      const authStore = useAuthStore();
      const storedIsActive = localStorage.getItem(ISACTIVE) === "true";

      authStore.isActive = storedIsActive;
      this.isActive = storedIsActive;

    },

    ...mapActions(useAuthStore, ["unSubscribeStc"]),

    async cancelSubscription() {
      await this.unSubscribeStc().then((response) => {
        this.redirectUser(response);
      });
    },

  async  redirectUser(response) {
      if (response?.data?.success) {
        // Update both store and local state
        const authStore = useAuthStore();
        authStore.isActive = false;
        this.isActive = false;
         this.wipeUserData();
          this.toast.success("تم إلغاء الإشتراك بنجاح");
        return this.$router.push({ name: "home" });
      }
    },

    logout() {
      this.wipeUserData();
      // Update local state since wipeUserData updates the store
      this.isActive = false;
      this.toast.success("تم تسجيل الخروج بنجاح");
      this.$router.push({ name: "home" });
    },
  }, //end of methods
};
</script>

<style></style>
